import { render, staticRenderFns } from "./word-context-panel.vue?vue&type=template&id=4d1dab3a&"
import script from "./word-context-panel.vue?vue&type=script&lang=js&"
export * from "./word-context-panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\uds\\projects\\alpheios\\components\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4d1dab3a', component.options)
    } else {
      api.reload('4d1dab3a', component.options)
    }
    module.hot.accept("./word-context-panel.vue?vue&type=template&id=4d1dab3a&", function () {
      api.rerender('4d1dab3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/word-list/word-context-panel.vue"
export default component.exports